export const messages = {
  en: {
    affiliateCommissionManage: {
      queryCondition: 'Query Conditions',
      selectCommissionRate: 'Please select commission rate',
      query: 'Query',
      affiliateOrder: 'Affiliate Orders',
      commissionId: 'Commission ID',
      affiliateId: 'Affiliate ID',
      relatedOrderId: 'Related Order ID',
      orderItemId: 'Order Item ID',
      orderUserId: 'Order User ID',
      relationLevel: 'Relation Level',
      commissionRate: 'Commission Rate',
      orderAmount: 'Order Amount',
      commissionAmount: 'Commission Amount',
      status: 'Status',
      createTime: 'Create Time',
      settlementTime: 'Settlement Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      level1: 'Level 1',
      level2: 'Level 2',
      state0: 'Pending',
      state1: 'Settled',
      state2: 'Canceled'
    },
    deleteAffiliateCommission: {
      confirmTitle: 'Please confirm your operation!',
      confirmText: 'Confirm to delete affiliate order?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    affiliateCommissionManage: {
      queryCondition: '查询条件',
      selectCommissionRate: '请选择佣金比例',
      query: '查询',
      affiliateOrder: '分销订单',
      commissionId: '佣金ID',
      affiliateId: '分销员ID',
      relatedOrderId: '关联订单ID',
      orderItemId: '订单项ID',
      orderUserId: '下单用户ID',
      relationLevel: '关系层级',
      commissionRate: '佣金比例',
      orderAmount: '订单金额',
      commissionAmount: '佣金金额',
      status: '状态',
      createTime: '创建时间',
      settlementTime: '结算时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      level1: '一级',
      level2: '二级',
      state0: '待结算',
      state1: '已结算',
      state2: '已取消'
    },
    deleteAffiliateCommission: {
      confirmTitle: '请确认您的操作！',
      confirmText: '确定删除分销订单？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}